NtechApp.CollectionIntro = function($view) {
    var me = this;

    this._$view = null;

    this._touchClickEvent = null;

    this._css = {
        ids: {
        },

        classes: {
        },

        data: {
        }
    }

    this._construct = function () {
        me._$view = $view;

        me._touchClickEvent = new NtechApp.TouchClickEvent();

        $("#pageMainHeading > .desktopHeading").imageScroll({
            holderMaxHeight: 220,
            container: $("#pageMainHeading")
        });

        me._bindEvents();
    }

    this._bindEvents = function () {
    }

    this._unbindEvents = function () {
        $("#pageMainHeading > .desktopHeading").imageScroll("destruct");
    }

    this.destruct = function () {
        me._unbindEvents();
    }

    this._construct();
    return this;
};